import { Signal, WritableSignal } from '@angular/core';

export enum GrantType {
  MSAL = 'msal',
}

export interface SecurityApiTokenModel {
  accessToken: string;
  expiresOn: string;
}

export interface SecurityApiToken {
  accessToken: string;
  expiresOn: Date;
  scopes: string;
  tenantId: string | null;
  refreshedToken: Signal<SecurityApiToken | null>;
}

export interface SecurityApiTokenCache extends SecurityApiToken {
  refreshedTokenSignal: WritableSignal<SecurityApiToken>;
}
